import Nullstack from 'nullstack';
export default function IconRegex({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-regex",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z"
  }), "   ", Nullstack.element("path", {
    d: "M17 7.875l3 -1.687"
  }), "   ", Nullstack.element("path", {
    d: "M17 7.875v3.375"
  }), "   ", Nullstack.element("path", {
    d: "M17 7.875l-3 -1.687"
  }), "   ", Nullstack.element("path", {
    d: "M17 7.875l3 1.688"
  }), "   ", Nullstack.element("path", {
    d: "M17 4.5v3.375"
  }), "   ", Nullstack.element("path", {
    d: "M17 7.875l-3 1.688"
  }), " ");
}